export default __webpack_public_path__ + "static/media/yesartworkssidebar.e9f21893.png";